import { BMotion2 } from './BMotion2';
import { BMotionType } from './BMotionEnums';
import { MathFunc } from '../Graphics/MathFunc';
import { KeyFrame } from '../KeyFrame/KeyFrame';
import { Constants } from '../Misc/Constants';

interface OpacityKeyFrame extends KeyFrame{
    opacity: number
}

export class Opacity extends BMotion2{
    readonly TYPE: BMotionType = BMotionType.FADE

    constructor(){
        super();
        this.createNewKeyFrame(0, [Constants.OPAQUE]);
        this.prepare();
        /*this.addKeyFrame(0.5, 48, true);
        this.addKeyFrame(1, 72, true);
        this.addKeyFrame(0, 90, true);*/
        //this.addKeyFrame(180, 48, true);
    }

    interpolate(interpolant : number, prev: OpacityKeyFrame, next: OpacityKeyFrame) : Array<number>{
        return [ MathFunc.interpolate(
            prev.opacity,
            next.opacity,
            interpolant) ];
    }

    //override
    protected resetComputedVal(){
        this._computedVal = [(this.keyFrames.get(0) as OpacityKeyFrame).opacity];
    }

    protected updateKeyFrameVal(frameNumber: number, newValue: number[]): void {
        //Parent checks if frame is available before call this method. So key frame is guaranteed to be available.
        (this.keyFrames.get(frameNumber) as OpacityKeyFrame).opacity = newValue[0];
    }
    
    protected createNewKeyFrame(frame: number, newValue: number[]): void {
        var opacity = newValue[0];
        var interpolate = true;
        let keyFrame = {opacity, frame, interpolate}
        this.keyFrames.add(frame, keyFrame)
    }

    clone(): BMotion2{
        var clone = new Opacity()
        super.duplicate(clone);
        for(var keyFrame of this.keyFrames.getKeys()){
            var tkf = this.keyFrames.get(keyFrame) as OpacityKeyFrame;
            clone.updateKeyFrame(keyFrame, [tkf.opacity]);
        }
        return clone;
    }
}